import {addToShoppingCart, getCartId, isCarDataInCart, getCartFromLocalStorage} from '../../shopping-cart/2023/shopping-cart-utils';
import analytics from '../../analytics.js';

/**
 * Place for small necessary functions that need to exist, but too small to need their own module
 * @param {object} carPageApp - CarPageApp object
 */
function init(carPageApp) {

  // simple method for opening the modal dialog
  const openDialog = event => {
    event.preventDefault();
    carPageApp.updateState('dialogs.contactDialog', 1);
  };

  /**
   * Either adds or removes the car from the shopping cart and opens the dialog in case of adding
   * @param {Event} event event object
   */
  const handleAddToCartClick = async event => {

    event.preventDefault();

    const state = carPageApp.getState();

    const isInCart = isCarDataInCart(state.carData, getCartFromLocalStorage());

    if (isInCart) {
      // Button will not remove the car at this point, but it will in the future.
      // removeFromShoppingCart(state.carData.license ?? state.carData.pid);
      //carPageApp.updateState('cart.isInCart', 0)
      location.href = '/ostoskori/';
    } else {
      await addToShoppingCart(state.carData.license ?? state.carData.pid);
      analytics.pushAddToCart(getCartId(), carPageApp.getState());
      // Modal is not going to be used at this point, but it will be used in the future.
      //carPageApp.updateState('dialogs.addCartDialog', 1);
      carPageApp.updateState('cart.isInCart', 1);
      location.href = '/ostoskori/';
    }
  };

  // controls which should open the modal
  document.querySelectorAll('#car-sticky-contact, button.contact-button').forEach(el => {
    el.addEventListener('click', openDialog);
  });

  document.querySelectorAll('button.add-cart-button').forEach(el => {
    el.addEventListener('click', handleAddToCartClick);
  });
}

export default { init };


